import React from "react";

const Contact = () => {
  return (
    <div class="main-other">
      <section class="body container">
        <div class="content-body d-flex justify-content-center align-items-center ht-500">
          <div class="shadow p-4 rounded bg-white">
            <h1 class="center content-header">Contact Us</h1>
            <p class="content-text my-12">Have any questions or need assistance? Our team is ready to support you with anything you need, from app features to troubleshooting. Don't hesitate to reach out to us at:</p>
            <a class="content-text" href="mail-to:sales@getnimbleapp.com">
              sales@getnimbleapp.com
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
